<template>
  <Mine_index v-if="config.mine_version == '1.0'"></Mine_index>
  <Mine_new v-else></Mine_new>
</template>

<script>
import Mine_index from './mine_old.vue';
import Mine_new from './mine_new.vue';
import { mapState } from 'vuex';
export default {
  components: {
    Mine_index,
    Mine_new
  },
  computed: {
    ...mapState(['config'])
  },
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style scoped></style>
